import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container } from "react-bootstrap";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentBandeau from "../../components/layout/ComponentBandeau";
import ComponentSousmenu from "../../components/layout/ComponentSousmenu";
import ComponentLoader from "../../components/layout/ComponentLoader";
import { apiGetProcesses } from "../../api/ApiProcess";
import { apiGetOrgunits } from "../../api/ApiOrgunit";
import { apiRecupEspacesGrantedColidee } from "../../api/ApiColidee";

import ComponentGovernanceViewMacro from "../../components/public/governance/ComponentGovernanceViewMacro";
import ComponentGovernanceViewFriseChrono from "../../components/public/governance/ComponentGovernanceViewFriseChrono";
import BlocToggle from "../../components/layout/ComponentToggle";
import BlocFiltreInGovernance from "../../components/public/governance/BlocFiltreInGovernance";

import { chgGovernanceToggle, selectInGouvernanceToggle } from "../../redux/ReduxToggle";
const PageIngovernance = () => {
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [processes, setProcesses] = useState([]);
  const [orgunitsRituel, setOrgunitsRituel] = useState([]);
  const [orgunitsTempsCollectif, setOrgunitsTempsCollectif] = useState([]);
  const [orgunitsRole, setOrgunitsRole] = useState([]);
  const [orgunitsPartiePrenante, setOrgunitsPartiePrenante] = useState([]);
  const [orgunitsPinned, setOrgunitsPinned] = useState([]);
  const [espaces, setEspaces] = useState([]);
  const [loader, setLoader] = useState(false);
  const [viewToggle, setViewToggle] = useState(useSelector(selectInGouvernanceToggle));
  const [anteriorite, setAnteriorite] = useState(31);
  const dispatch = useDispatch();

  const recupDatas = async () => {
    setLoader(true);
    // récupération Espaces Colidée
    var espacesSouhaites = [];
    const resProcesses = await apiGetProcesses(
      ReduxInstance._id,
      "filter[famille]=MacroProcess&sort=-ordre&include=orgunits",
    );
    resProcesses.data.map(
      (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces)),
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);
    const form = new FormData();
    form.append("espacesSouhaites", espacesSouhaites.join(","));
    const resEspaces = await apiRecupEspacesGrantedColidee(ReduxToken, form);

    if (resEspaces.data) {
      resEspaces.data.sort((b, a) =>
        a.dateDerniereContrib > b.dateDerniereContrib
          ? 1
          : b.dateDerniereContrib > a.dateDerniereContrib
            ? -1
            : 0,
      );
      setEspaces(resEspaces.data);
    }

    // récupération Orgunits
    const resOrgunits = await apiGetOrgunits(ReduxInstance._id);
    setOrgunitsRituel(
      resOrgunits.data.filter((orgunit) => orgunit.type === "Rituel" && !orgunit.enSommeil),
    );
    setOrgunitsTempsCollectif(
      resOrgunits.data.filter(
        (orgunit) => orgunit.type === "Temps collectif" && !orgunit.enSommeil,
      ),
    );
    setOrgunitsRole(
      resOrgunits.data.filter((orgunit) => orgunit.type === "Rôle" && !orgunit.enSommeil),
    );
    setOrgunitsPartiePrenante(
      resOrgunits.data.filter(
        (orgunit) => orgunit.type === "Partie prenante" && !orgunit.enSommeil,
      ),
    );

    // récupération Processes
    setProcesses(resProcesses.data);
    setLoader(false);
  };

  const switchView = () => {
    dispatch(chgGovernanceToggle(!viewToggle));
    setViewToggle(!viewToggle);
  };

  useEffect(() => {
    recupDatas();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu menuActif="ingovernance" />
      <div className="containerHeaderBandeau">
        <ComponentBandeau menu="inGovernance" isCalendarView={viewToggle} />
        <BlocToggle
          viewToggle={viewToggle}
          switchView={switchView}
          setAnteriorite={setAnteriorite}
          anteriorite={anteriorite}
          curseurInitial={1}
          max={5}
          min={0}
          sousMenus={ReduxInstance.sousMenus.filter((item) => item.parent === "inGovernance")}
        />
      </div>

      <BlocFiltreInGovernance viewToggle={viewToggle} />

      {loader && (
        <div className="text-center ">
          <ComponentLoader />
        </div>
      )}
      {!loader && (
        <Container fluid>
          {viewToggle && (
            <ComponentGovernanceViewFriseChrono
              espaces={espaces}
              orgunitsRituel={orgunitsRituel}
              orgunitsTempsCollectif={orgunitsTempsCollectif}
              anteriorite={anteriorite}
            />
          )}
          {!viewToggle && <ComponentGovernanceViewMacro processes={processes} espaces={espaces} />}
        </Container>
      )}
    </>
  );
};

export default PageIngovernance;
